import { Injectable } from '@angular/core';
import { RoutingService, ProductSearchPage, SearchConfig } from '@spartacus/core';
import { Observable, Subject } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { UigProductSearchAdapter } from './uig-product-search.adapter';

@Injectable({
  providedIn: 'root',
})
export class UigExportProductSearchService {

  private result: ProductSearchPage;
  private loading$ = new Subject<boolean>();

  constructor(
    private routing: RoutingService,
    private uigProductSearchAdapter: UigProductSearchAdapter
  ) {
    this.loading$.next(false);
  }


  productSearch(query: string, searchConfig?: SearchConfig): void {
    this.loading$ = new Subject<boolean>();
    this.loading$.next(true);
    this.uigProductSearchAdapter
      .productSearch(query, searchConfig)
      .pipe(
        filter((response) => response != null),
        tap((response) => {
          this.result = response;
          this.loading$.next(false);
        })
      ).subscribe();
  }

  getLoading(): Subject<boolean> {
    return this.loading$;
  }

  getResult(): ProductSearchPage {
    return this.result;
  }

}
